const labels = ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D', 'E', 'F', 'G'];
const colors = [
  'green500',
  'green400',
  'green300',
  'yellow100',
  'orange500',
  'orange400',
  'red100',
  'red100',
  'red100',
  'red100',
];

export const getScaledEnergyLabelsColor = (min: string, max: string) => {
  const maxIndex = labels.indexOf(max);
  const minIndex = labels.indexOf(min);
  const scaledLabels = labels.slice(maxIndex, minIndex + 1);
  return Object.fromEntries(
    scaledLabels.map((label, index) => [label, colors[index]]),
  );
};
